// extracted by mini-css-extract-plugin
module.exports = {"root":"u-spinner__11HJBllV","linear-spin":"u-spinner_linear-spin__11HJBllV"};